import React, { useReducer } from "react";
import Medusa from "../services/api";

export const defaultAccountContext = {
  isLoggedIn: false,
  id: "",
  name: "",
  first_name: "",
  last_name: "",
  email: "",
  phone: "",
  role: "",
  account_type: "",
  account_status: "",
  profile_update_level: 0,
  verification_level: 0,
  referred_by_id: null,
  rating: -1,
  visibility: null,
  metadata: {},
};

export const AccountContext = React.createContext(defaultAccountContext);

const reducer = (state, action) => {
  switch (action.type) {
    case "userAuthenticated":
      return {
        ...state,
        isLoggedIn: true,
        id: action.payload.id,
        email: action.payload.email,
        phone: action.payload.phone,
        first_name: action.payload?.first_name,
        last_name: action.payload?.last_name,
        role: action.payload.role,
        account_type: action.payload.account_type,
        account_status: action.payload.account_status,
        profile_update_level: action.payload.profile_update_level,
        verification_level: action.payload.verification_level,
        referred_by_id: action.payload.referred_by_id,
        rating: action.payload.rating,
        visibility: action.payload.visibility,
        metadata: action.payload.metadata ? action.payload.metadata : {},
      };
    case "updateUser":
      return {
        ...state,
        ...action.payload,
      };
    case "userLoggedOut":
      return defaultAccountContext;
    case "userLoggedIn":
      return {
        ...state,
        isLoggedIn: true,
        id: action.payload.id,
        email: action.payload.email,
        phone: action.payload.phone,
        first_name: action.payload?.first_name,
        last_name: action.payload?.last_name,
        role: action.payload.role,
        account_type: action.payload.account_type,
        account_status: action.payload.account_status,
        profile_update_level: action.payload.profile_update_level,
        verification_level: action.payload.verification_level,
        referred_by_id: action.payload.referred_by_id,
        rating: action.payload.rating,
        visibility: action.payload.visibility,
        metadata: action.payload.metadata ? action.payload.metadata : {},
      };
    default:
      return state;
  }
};

export const AccountProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, defaultAccountContext);

  const session = () => {
    console.log("Session...");
    return Medusa.auth.session().then(({ data }) => {
      console.log("Session", data);
      dispatch({ type: "userAuthenticated", payload: data.user });
      return data;
    });
  };

  return (
    <AccountContext.Provider
      value={{
        ...state,
        session,
        handleUpdateUser: (id, user) => {
          if (user["metadata"]) {
            user["metadata"] = {
              ...state.metadata,
              ...user["metadata"],
            };
          }

          return Medusa.users.update(id, user).then(({ data }) => {
            dispatch({ type: "updateUser", payload: data.user });
          });
        },

        handleLogout: (details) => {
          return Medusa.auth.deauthenticate(details).then(() => {
            localStorage.setItem("uid", "");
            dispatch({ type: "userLoggedOut" });
            return null;
          });
        },

        handleLogin: (details) => {
          return Medusa.auth.authenticate(details).then(({ data }) => {
            localStorage.setItem("uid", data?.user?.id);
            dispatch({ type: "userLoggedIn", payload: data.user });

            return data;
          });
        },
        handleRegister: (details) => {
          return Medusa.account.register(details).then(({ data }) => {
            return data;
          });
        },
        handleUpdate: (id, details) => {
          if (details["metadata"]) {
            details["metadata"] = {
              ...state.metadata,
              ...details["metadata"],
            };
          }
          return Medusa.account.update(id, details).then(({ data }) => {
            dispatch({ type: "userLoggedIn", payload: data.user });
            return data;
          });
        },
        handleResetPassword: (details) => {
          return Medusa.account.resetPassword(details).then(({ data }) => {
            return data;
          });
        },
        handleDeleteMyAccount: () => {
          return Medusa.users.deleteMyAccount().then(({ data }) => {
            localStorage.setItem("uid", "");
            return data;
          });
        },
        handleRefresh: () => {
          if (state.id) {
            return Medusa.account.get(state.id).then(({ data }) => {
              dispatch({ type: "updateUser", payload: data.user });
              return data;
            });
          }
        },
      }}
    >
      {children}
    </AccountContext.Provider>
  );
};
